import { Component, OnInit, OnDestroy } from '@angular/core';
import { LocalizationService } from 'src/app/modules/shared/services/localization.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectAppSettings } from '../../../../state/selectors/app-settings.selectors';
import { AppState } from '../../../../app.state';

@Component({
  selector: 'aca-register-disclaimer-screen',
  templateUrl: './register-disclaimer-screen.component.html',
  styleUrls: ['./register-disclaimer-screen.component.css']
})
export class RegisterDisclaimerScreenComponent implements OnInit, OnDestroy {

  adminMode: boolean;
  protected destroyActions = new Subject<boolean>();

  constructor(private localizationService: LocalizationService, private store: Store<AppState>) { }

  ngOnInit(): void {
    this.store.select(selectAppSettings)
      .pipe(takeUntil(this.destroyActions))
      .subscribe({
        next: state => {
          this.adminMode = state.AdminMode;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyActions.next(null);
    this.destroyActions.complete();
  }
}
